import React, { useState, Suspense, useEffect, useRef, useLayoutEffect, createRef } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect } from "react-router-dom";
import { safeAddMediaQueryListener } from '../utils/matchMediaUtils';
import Cookies from 'js-cookie';
import PageLoader from './common/PageLoader';
import { HEADING_LINK, CREATE_RESUME, SITE_DOMAIN, COOKIE_DOMAIN, QUICK_EDITOR, DASHBOARD_LINK, CHOOSE_COLOR, FINAL_RESUME } from '../constants/constants';
import { updateProfilePictureStatus, updateTemplate } from '../services/actions/actions';
import LazyLoad from 'react-lazy-load';
let TPL = {}
TPL['template-one'] = React.lazy(() => import('./resumetemplates/static/TemplateOne'));
TPL['template-one-v2'] = React.lazy(() => import('./resumetemplates/static/TemplateOneV2'));
TPL['template-one-v3'] = React.lazy(() => import('./resumetemplates/static/TemplateOneV3'));
TPL['template-two'] = React.lazy(() => import('./resumetemplates/static/TemplateTwo'));
TPL['template-two-v2'] = React.lazy(() => import('./resumetemplates/static/TemplateTwoV2'));
TPL['template-two-v3'] = React.lazy(() => import('./resumetemplates/static/TemplateTwoV3'));
TPL['template-three'] = React.lazy(() => import('./resumetemplates/static/TemplateThree'));
TPL['template-three-v2'] = React.lazy(() => import('./resumetemplates/static/TemplateThreeV2'));
TPL['template-three-v3'] = React.lazy(() => import('./resumetemplates/static/TemplateThreeV3'));
TPL['template-three-v4'] = React.lazy(() => import('./resumetemplates/static/TemplateThreeV4'));
TPL['template-three-v5'] = React.lazy(() => import('./resumetemplates/static/TemplateThreeV5'));
TPL['template-four'] = React.lazy(() => import('./resumetemplates/static/TemplateFour'));
TPL['template-four-v2'] = React.lazy(() => import('./resumetemplates/static/TemplateFourV2'));
TPL['template-four-v3'] = React.lazy(() => import('./resumetemplates/static/TemplateFourV3'));
TPL['template-four-v4'] = React.lazy(() => import('./resumetemplates/static/TemplateFourV4'));
TPL['template-four-v5'] = React.lazy(() => import('./resumetemplates/static/TemplateFourV5'));
TPL['template-five'] = React.lazy(() => import('./resumetemplates/static/TemplateFive'));
TPL['template-five-v2'] = React.lazy(() => import('./resumetemplates/static/TemplateFiveV2'));
TPL['template-five-v3'] = React.lazy(() => import('./resumetemplates/static/TemplateFiveV3'));
TPL['template-five-v4'] = React.lazy(() => import('./resumetemplates/static/TemplateFiveV4'));
TPL['template-five-v5'] = React.lazy(() => import('./resumetemplates/static/TemplateFiveV5'));
TPL['template-six'] = React.lazy(() => import('./resumetemplates/static/TemplateSix'));
TPL['template-six-v2'] = React.lazy(() => import('./resumetemplates/static/TemplateSixV2'));
TPL['template-six-v3'] = React.lazy(() => import('./resumetemplates/static/TemplateSixV3'));
TPL['template-seven'] = React.lazy(() => import('./resumetemplates/static/TemplateSeven'));
TPL['template-seven-v2'] = React.lazy(() => import('./resumetemplates/static/TemplateSevenV2'));
TPL['template-seven-v3'] = React.lazy(() => import('./resumetemplates/static/TemplateSevenV3'));
TPL['template-eight'] = React.lazy(() => import('./resumetemplates/static/TemplateEight'));
TPL['template-eight-v2'] = React.lazy(() => import('./resumetemplates/static/TemplateEightV2'));
TPL['template-eight-v3'] = React.lazy(() => import('./resumetemplates/static/TemplateEightV3'));
TPL['template-nine'] = React.lazy(() => import('./resumetemplates/static/TemplateNine'));
TPL['template-nine-v2'] = React.lazy(() => import('./resumetemplates/static/TemplateNineV2'));
TPL['template-nine-v3'] = React.lazy(() => import('./resumetemplates/static/TemplateNineV3'));
TPL['template-ten'] = React.lazy(() => import('./resumetemplates/static/TemplateTen'));
TPL['template-ten-v2'] = React.lazy(() => import('./resumetemplates/static/TemplateTenV2'));
TPL['template-ten-v3'] = React.lazy(() => import('./resumetemplates/static/TemplateTenV3'));
TPL['template-ten-v4'] = React.lazy(() => import('./resumetemplates/static/TemplateTenV4'));
TPL['template-ten-v5'] = React.lazy(() => import('./resumetemplates/static/TemplateTenV5'));
TPL['template-eleven'] = React.lazy(() => import('./resumetemplates/static/TemplateEleven'));
TPL['template-twelve'] = React.lazy(() => import('./resumetemplates/static/TemplateTwelve'));
TPL['template-thirteen'] = React.lazy(() => import('./resumetemplates/static/TemplateThirteen'));
TPL['template-fourteen'] = React.lazy(() => import('./resumetemplates/static/TemplateFourteen'));
TPL['template-fifteen'] = React.lazy(() => import('./resumetemplates/static/TemplateFifteen'));
TPL['template-sixteen'] = React.lazy(() => import('./resumetemplates/static/TemplateSixteen'));
// TPL['template-sixteen-v2'] = React.lazy(() => import('./resumetemplates/static/TemplateSixteenV2'));
TPL['template-seventeen'] = React.lazy(() => import('./resumetemplates/static/TemplateSeventeen'));
TPL['template-eighteen'] = React.lazy(() => import('./resumetemplates/static/TemplateEighteen'));
TPL['template-nineteen'] = React.lazy(() => import('./resumetemplates/static/TemplateNineteen'));
TPL['template-twenty'] = React.lazy(() => import('./resumetemplates/static/TemplateTwenty'));
TPL['template-twenty-one'] = React.lazy(() => import('./resumetemplates/static/TemplateTwentyOne'));
TPL['template-twenty-five'] = React.lazy(() => import('./resumetemplates/static/TemplateTwentyFive'));
TPL['template-twenty-three'] = React.lazy(() => import('./resumetemplates/static/TemplateTwentyThree'));
TPL['template-twenty-four'] = React.lazy(() => import('./resumetemplates/static/TemplateTwentyFour'));
TPL['template-thirty-one'] = React.lazy(() => import('./resumetemplates/static/TemplateThirtyOne'));
// TPL['template-thirty-two'] = React.lazy(() => import('./resumetemplates/static/TemplateThirtyTwo'));
// TPL['template-thirty-three'] = React.lazy(() => import('./resumetemplates/static/TemplateThirtyThree'));
// TPL['template-thirty-four'] = React.lazy(() => import('./resumetemplates/static/TemplateThirtyFour'));
// TPL['template-thirty-five'] = React.lazy(() => import('./resumetemplates/static/TemplateThirtyFive'));
// TPL['template-thirty-six'] = React.lazy(() => import('./resumetemplates/static/TemplateThirtySix'));
// TPL['template-thirty-seven'] = React.lazy(() => import('./resumetemplates/static/TemplateThirtySeven'));
// TPL['template-thirty-eight'] = React.lazy(() => import('./resumetemplates/static/TemplateThirtyEight'));
// TPL['template-thirty-nine'] = React.lazy(() => import('./resumetemplates/static/TemplateThirtyNine'));
// TPL['template-twenty-six'] = React.lazy(() => import('./resumetemplates/static/TemplateTwentySix'));
const ListTemplate = (props) => {
  const rows = props.hasOwnProperty('rows') ? props.rows : 1;
  const templates = props.templates;
  const color = props.color;
  const customColor = props.customColor;
  const headerColor = props.headerColor;
  const page = props.page;
  const [redirect, setRedirect] = useState(false);
  const [singleItemHeight, setSingleItemHeight] = useState('100%');
  const [singleItemWidth, setSingleItemWidth] = useState("auto");
  const dispatch = useDispatch();
  const refs = useRef(templates.map(createRef));

  useLayoutEffect(() => {
    setTimeout(() => {
      if(refs.current[0].current != null){
        setSingleItemWidth(refs.current[0].current.offsetWidth);
        let sih = (refs.current[0].current.offsetHeight != 0 && refs.current[0].current.offsetHeight > singleItemHeight ? refs.current[0].current.offsetHeight : singleItemHeight);
        sih = (refs.current[0].current.offsetTop > sih ? refs.current[0].current.offsetTop : sih);
        setSingleItemHeight(sih);
      }
    }, 300);
  }, [refs]);

  //To Set resumes scaling according to card size
  const scalingAreaElements = useRef([]);
  const observer = useRef(null);

  const changeScale = () => {
    const elements = scalingAreaElements.current;

    if (elements.length > 0) {
      const templateItem = document.getElementsByClassName('template-single-item')[0];
      
      // Check if the template item exists before accessing its properties
      if (!templateItem) {
        console.warn('changeScale: template-single-item element not found');
        return;
      }

      const computedStyle = window.getComputedStyle(templateItem);
      const borderWidth = (parseFloat(computedStyle.borderLeftWidth) || 0) + (parseFloat(computedStyle.borderRightWidth) || 0);
      for (let i = 0; i < elements.length; i++) {
        const width = (templateItem.offsetWidth != 0
        ? templateItem.offsetWidth - borderWidth
        : 'auto');      
        elements[i].style.transform = `scale(${width / 641})`;
      }
    }
  };

  useEffect(() => {
    const observerCallback = (mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          scalingAreaElements.current = Array.from(
            document.querySelectorAll('.template-single-item .scaling-area')
          );
         changeScale();
        }
      }
      const templateItems = document.getElementsByClassName('template-single-item');
      if (templateItems.length > 0) {
        const firstTemplateItem = templateItems[0];
        if (!firstTemplateItem) {
          console.warn('observerCallback: .template-single-item not found');
          return;
        }

        for (let i = 0; i < templateItems.length; i++) {
          const width = (firstTemplateItem.offsetWidth != 0
          ? firstTemplateItem.offsetWidth
          : 'auto');
          const h = (width != 'auto' ? `${width / 0.75}px` : '150px');
          templateItems[i].style.height = h;
          const sih = (width != 'auto' ? width / 0.75 : '150px')
          setSingleItemHeight(sih);
        }
      }
    };

    const options = { childList: true, subtree: true };
    observer.current = new MutationObserver(observerCallback);
    observer.current.observe(document.body, options);

    return () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    };
  }, []);

  useEffect(() => {
    scalingAreaElements.current = Array.from(
      document.querySelectorAll('.template-single-item .scaling-area')
    );
    changeScale();
    // Set Scaling when device orientation changes
    let portrait = window.matchMedia("(orientation: portrait)");
    
    // Use safe media query listener for cross-browser compatibility
    safeAddMediaQueryListener(portrait, function(e) {
        if(e.matches) {
            // Portrait mode
            changeScale();
        } else {
          // Landscape Mode
          changeScale();
        }
    });
  }, []);
  const templateGroups = rows > 1 ? templates.map((e, i) => {
    return i % rows === 0 ? templates.slice(i, i + rows) : null;
  }).filter(e => { return e; }) : [];
  if (redirect && page == 'choose-template'){
    history.pushState(null, DASHBOARD_LINK); 
    return <Redirect to={CREATE_RESUME  } /> 
  }
  return (
    <div className="template-items" id="template-item-id">
      {templates.length ? templates.map((template, index) => {
        const TplName = TPL[template.id];
        
        return (
          <div className={`template-single-item${props.resume?.active_template == template.id ? ' border' : ''}`} key={template.id}>
            {/* <div>{template.id}</div> */}
             <LazyLoad height={singleItemHeight} width={singleItemWidth} threshold={window.innerWidth < 1200 ?  0.2 : .4} onContentVisible={() => { console.log('loaded!')}}>
            <div
              role="button"
              ref={refs.current[index]} 
              className={`template-item ` + color}
              onClick={() => {
                if(props.page == 'choose-template' ){
                  try {
                    localStorage.setItem('selected_color', color ? color : template.color);
                    localStorage.setItem('selected_template', template.id);
                    localStorage.setItem('selected_custom_color', customColor ? customColor : '');
                  } catch (error) {
                    console.error("Could not access localStorage:", error);
                  }
                }else{
                  dispatch(updateTemplate(customColor ? customColor : '', color ? color : template.color, template.id))
                }
                dispatch(updateProfilePictureStatus(template.id));
                let ua_cat = (
                  props.hasOwnProperty('pagepage') && props.page == 'quick-editor' 
                  ? 'Quick Editor' 
                  : 'Choose Template'
                );
                gaTrack('RB App', ua_cat, `Template ${template.id}`);
                let ga_cat = (
                  props.hasOwnProperty('page') && props.page == 'quick-editor' 
                  ? 'app_quick_editor_template_' 
                  : 'app_choose_template_'
                ) + template.id;
                ga4Track(ga_cat, 'RB App', `Template ${template.id}`);
                setRedirect(true);
              }}
            >
              <Suspense fallback={<PageLoader />}>
                {Object.keys(TPL).includes(template.id) ? (
                  <div className="static-view" >
                    <TplName color={color ? color : template.color} customColor={customColor} headerColor={headerColor} />
                  </div>)
                  : (
                  ""
                )}
              </Suspense>
            </div>
              
            </LazyLoad>
            {/* Added lable only for ATS templates */}
            {(template.id === 'template-ten' || 
              template.id === 'template-ten-v2' || 
              template.id === 'template-ten-v3'||
              template.id === 'template-ten-v4'||
              template.id === 'template-ten-v5')  
              &&
                <div  className="bottom-label"><span className="ff-helvetica-bold">ATS-Friendly</span></div>
              }
           </div>
        );
      }) : <PageLoader />}
    </div>
  )
}
export default ListTemplate;
